// export const formatPrice = (price: number) =>
//   Math.round(price).toLocaleString('ru-RU') + ' ₽';

export const formatPrice = (price: number, digits: number = 0) =>
  new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(price) + ' ₽';
